/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import * as React from 'react'
import { useUserPermissions } from 'src/hooks/useUserPermissions'
import { Roles } from '@rdTypes/shared'
import { useGetMyProfileQuery } from 'src/redux/api/user'
import { getHostWithPrefix } from 'src/utils'

const OpenCvContext = React.createContext({ loaded: false,
  cv: undefined })

const { Consumer: OpenCvConsumer, Provider } = OpenCvContext

export { OpenCvConsumer, OpenCvContext }

const scriptId = 'opencv-react'
const moduleConfig = {
  wasmBinaryFile: 'opencv_js.wasm',
  usingWasm: true
}

export const OpenCvProvider = ({
  openCvVersion = '3.4.16',
  openCvPath = '',
  children,
}) => {
  const [cvInstance, setCvInstance] = React.useState({
    loaded: false,
    cv: undefined
  })

  const { isAllowed } = useUserPermissions();
  const { data } = useGetMyProfileQuery();

  React.useEffect(() => {
    if (!isAllowed([Roles.Admin, Roles.Mailroom])) return;
    if (document.getElementById(scriptId) || window.cv || cvInstance.loaded) {
      setCvInstance({ loaded: true, cv: window.cv })
      return
    }

    // https://docs.opencv.org/3.4/dc/de6/tutorial_js_nodejs.html
    // https://medium.com/code-divoire/integrating-opencv-js-with-an-angular-application-20ae11c7e217
    // https://stackoverflow.com/questions/56671436/cv-mat-is-not-a-constructor-opencv
    moduleConfig.onRuntimeInitialized = () => {
      setCvInstance({ loaded: true, cv: window.cv })
    }
    window.Module = moduleConfig

    const generateOpenCvScriptTag = () => {
      if (!data?.company.subdomain) return;
      const js = document.createElement('script')
      js.id = scriptId
      js.src =
        openCvPath || import.meta.env.VITE_APP_OPENCV_URL,

      js.nonce = true
      js.defer = true
      js.async = true

      return js
    }

    setTimeout(() => document.body.appendChild(generateOpenCvScriptTag()), 100);
  }, [openCvPath, openCvVersion])

  return <Provider value={cvInstance}>{children}</Provider>
}
